import { render, staticRenderFns } from "./system-refresh-redis.vue?vue&type=template&id=73f8d22c&"
import script from "./system-refresh-redis.vue?vue&type=script&lang=js&"
export * from "./system-refresh-redis.vue?vue&type=script&lang=js&"
import style0 from "./system-refresh-redis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports